@import "../../themes/stories.globals";

:host {
  height: 100%;
  width: 100%;
  background-color: coral;
}
